export default __webpack_public_path__ + "static/media/portfolio-3.80ecc9ef.jpg";